/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

import { Link } from 'react-router-dom';

function Button(props) {
    if(props.type == "route") {
        if(props.active == false) {
            return (
                <Link className="bg-primary hover:bg-secondary px-6 py-3 text-gray-100 cursor-pointer hover:text-white rounded-lg transition cursor-not-allowed">
                    {props.title}
                </Link>
            )
        } else {
            return (
                <Link to={props.link} className="bg-primary hover:bg-secondary px-6 py-3 text-gray-100 cursor-pointer hover:text-white rounded-lg transition">
                    {props.title}
                </Link>
            )
        }
    } else {
        if(props.active == false) {
            return (
                <a className="bg-primary hover:bg-secondary px-6 py-3 text-gray-100 cursor-pointer hover:text-white rounded-lg transition cursor-not-allowed">
                    {props.title}
                </a>
            )
        } else {
            return (
                <a href={props.link} className="bg-primary hover:bg-secondary px-6 py-3 text-gray-100 cursor-pointer hover:text-white rounded-lg transition">
                    {props.title}
                </a>
            )
        }
    }
}

export default Button